import { useParams } from 'react-router-dom';
import { TaskDetailContent } from '../components/TaskDetailContent';

export const TaskDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  if (id == null) return null;
  return <TaskDetailContent id={id} />;
};
